// TOP エリア選択オーバーレイ（Figma PC 5124:33767 / SP 5124:33920）
// 初回訪問（総合版 かつ 同一セッションで未dismiss）で表示。
//   - エリアを選ぶ       → 都道府県版TOPへ遷移（URLのエリア接頭辞がそのまま状態になる）
//   - 総合版へ           → 総合TOP（/）へ遷移
//   - 選択せずに閉じる   → モーダルを閉じるだけ（選択状態は維持）
// gnav「物件をさがす」等 → いつでも強制オープン
//
// ※エリアはURLパス接頭辞が唯一の情報源でJSからは分からないため、モード判定は body[data-site-mode] を見る
const DISMISS_KEY = 'ymh_home_popup_dismissed';
const CMS_PRICE_DOWN_FEATURE = 'price_down';
const CMS_NEW_HOUSE_FEATURE = 'new_house';

const isAreaMode = () => document.body.dataset.siteMode === 'area';
const urlPrefix = () => (document.querySelector('meta[name="url-prefix"]')?.content || '').replace(/^\/+|\/+$/g, '');

const normalizeAppPath = (pathname) => {
    let path = pathname.replace(/\/+$/g, '') || '/';
    const prefix = urlPrefix();

    if (!prefix) return path;

    const prefixPath = `/${prefix}`;
    if (path === prefixPath) return '/';
    if (path.startsWith(`${prefixPath}/`)) {
        path = path.slice(prefixPath.length) || '/';
    }

    return path;
};

const isCmsLink = (link, entryUrl) => {
    try {
        if (!entryUrl) return false;
        const href = new URL(link.href, window.location.href);
        const entry = new URL(entryUrl, window.location.href);

        return href.origin === window.location.origin
            && normalizeAppPath(href.pathname) === normalizeAppPath(entry.pathname);
    } catch (e) {
        return false;
    }
};

const cmsFeatureRequest = () => {
    try {
        return new URLSearchParams(window.location.search).get('feature') || '';
    } catch (e) {
        return '';
    }
};

const cleanupCmsFeatureRequest = () => {
    if (!window.history?.replaceState) return;

    try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has('feature')) return;
        url.searchParams.delete('feature');
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    } catch (e) {
        /* noop */
    }
};

const main = () => {
    const popup = document.querySelector('.js-home-popup');
    if (!popup) return;

    // フローティング「おすすめ物件」など: 県選択後におすすめモーダルを開く
    let pendingFeature = false;
    // PICK UP「おすすめ物件をみる」: 県選択後にその県のおすすめ一覧へ直接遷移する
    let pendingRecommend = false;
    // 特集バナー（価格改定 / 即入居可）: 県選択後にその県の絞り込み一覧へ直接遷移する
    let pendingPriceDown = false;
    let pendingMoveIn = false;
    // おすすめ・特集物件モーダルのタグ（駐車場2台以上 / 4LDK以上 / 新築土地50坪以上 / 大規模開発分譲地）も同じ扱い
    let pendingParking = false;
    let pendingFloorPlan = false;
    let pendingLandArea = false;
    let pendingLargeDevelopment = false;
    let pendingNewsId = null;
    // CMSニュース本文の /price-down: 県選択後にその県の価格改定一覧へ直接遷移する
    let pendingCmsPriceDown = false;
    // CMSニュース本文の /new-house: 県選択後にその県の新築一戸建て一覧へ直接遷移する
    let pendingCmsNewHouse = false;
    // ヘッダー・フッター「物件を探す」の検索4種（data-home-popup-to="search-area" 等）:
    // 県選択後にその県の検索ページ（各県リンクの data-home-url-<キー>）へ直接遷移する。
    // 行き先ごとにフラグを増やさず、キー1つで持つ
    let pendingTo = null;

    const open = () => {
        popup.setAttribute('data-active', 'true');
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    };
    const clearPending = () => {
        pendingFeature = false;
        pendingRecommend = false;
        pendingPriceDown = false;
        pendingMoveIn = false;
        pendingParking = false;
        pendingFloorPlan = false;
        pendingLandArea = false;
        pendingLargeDevelopment = false;
        pendingNewsId = null;
        pendingCmsPriceDown = false;
        pendingCmsNewHouse = false;
        pendingTo = null;
    };

    // 「選択せずに閉じる」／オーバーレイ／Esc → 閉じるだけ
    const closeOnly = () => {
        clearPending();
        popup.setAttribute('data-active', 'false');
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) { /* noop */ }
    };

    popup.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', closeOnly));
    // 「総合版へ」はリンク。遷移前にdismissだけ記録する
    popup.querySelectorAll('.js-home-popup-national').forEach((el) => {
        el.addEventListener('click', () => {
            try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) { /* noop */ }
        });
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.getAttribute('data-active') === 'true') closeOnly();
    });

    // エリア選択 → 都道府県版TOP（aタグのhref）へ遷移
    // 通常: そのままエリアTOPへ（ymh_search_popup_pending で SEARCH ポップアップ1回表示）
    // data-home-popup-feature あり: エリアTOPへ → おすすめモーダル1回表示
    // data-home-popup-recommend あり: エリアTOPを経由せずその県のおすすめ一覧へ
    // data-home-popup-price-down / -move-in / -parking / -floor-plan / -land-area / -large-development あり:
    //   同じくその県の特集絞り込み一覧へ
    // data-home-popup-to="search-area" 等あり: その県の検索ページ（/{県}/search/area 等）へ
    popup.querySelectorAll('.js-home-popup-area').forEach((link) => {
        link.addEventListener('click', (e) => {
            const openFeature = pendingFeature;
            const toRecommend = pendingRecommend;
            const toPriceDown = pendingPriceDown;
            const toMoveIn = pendingMoveIn;
            const toParking = pendingParking;
            const toFloorPlan = pendingFloorPlan;
            const toLandArea = pendingLandArea;
            const toLargeDevelopment = pendingLargeDevelopment;
            const newsId = pendingNewsId;
            const toCmsPriceDown = pendingCmsPriceDown;
            const toCmsNewHouse = pendingCmsNewHouse;
            const to = pendingTo;
            clearPending();

            // 地図も都道府県版のような別タブにはしない（モーダルを閉じた直後に別タブが開くのは唐突なため）
            const toUrl = to ? link.getAttribute(`data-home-url-${to}`) : '';
            if (toUrl) {
                e.preventDefault();
                window.location.href = toUrl;
                return;
            }

            // 遷移先が変わるだけなので、feature側のような sessionStorage 経由の受け渡しは不要。
            // URLはBladeが描いた属性をそのまま使う（JSで組むと本番の '/bunjo' 接頭辞が落ちる）
            if (toRecommend || toPriceDown || toMoveIn || toParking || toFloorPlan || toLandArea || toLargeDevelopment || newsId || toCmsPriceDown || toCmsNewHouse) {
                const newsUrl = newsId && link.dataset.homeUrlNewsDetailTemplate
                    ? link.dataset.homeUrlNewsDetailTemplate.replace('__NEWS_ID__', encodeURIComponent(newsId))
                    : '';
                const directUrl = (toRecommend && link.dataset.homeUrlRecommend)
                    || (toCmsPriceDown && link.dataset.homeUrlCmsPriceDown)
                    || (toCmsNewHouse && link.dataset.homeUrlCmsNewHouse)
                    || newsUrl
                    || (toPriceDown && link.dataset.homeUrlPriceDown)
                    || (toMoveIn && link.dataset.homeUrlMoveIn)
                    || (toParking && link.dataset.homeUrlParking)
                    || (toFloorPlan && link.dataset.homeUrlFloorPlan)
                    || (toLandArea && link.dataset.homeUrlLandArea)
                    || (toLargeDevelopment && link.dataset.homeUrlLargeDevelopment)
                    || '';
                if (directUrl) {
                    e.preventDefault();
                    window.location.href = directUrl;
                }
                return; // 属性が無い場合はhrefのまま（都道府県版TOP）へ遷移
            }

            if (openFeature) {
                try { sessionStorage.setItem('ymh_feature_popup_pending', '1'); } catch (err) { /* noop */ }
                return; // hrefのまま遷移
            }
            try { sessionStorage.setItem('ymh_search_popup_pending', '1'); } catch (err) { /* noop */ }
            // hrefのまま遷移
        });
    });

    // gnav「物件をさがす」／ドロワー「エリアからさがす」などから強制オープン
    // gnav本体（data-search-popup-trigger）のみ、都道府県版では
    // 都道府県選択ポップアップの代わりにSEARCHポップアップを開く。
    // 「◯◯版」切替ボタン・ドロワー内「エリアから探す」は常に地図モーダルを開く。
    const searchPopup = document.querySelector('.js-home-search-popup');
    document.querySelectorAll('.js-home-popup-open, [data-home-popup-open]').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            // SPドロワーから開く場合はメニューを閉じる
            if (document.body.hasAttribute('data-menu-active')) {
                document.body.removeAttribute('data-menu-active');
                document.querySelectorAll('.js-drawer-toggle').forEach((btn) => {
                    btn.setAttribute('aria-expanded', 'false');
                });
            }
            if (el.hasAttribute('data-search-popup-trigger') && isAreaMode() && searchPopup) {
                clearPending();
                searchPopup.setAttribute('data-active', 'true');
                searchPopup.setAttribute('aria-hidden', 'false');
                document.body.style.overflow = 'hidden';
                return;
            }
            // 他のトリガーから開いたときに前回の状態が残らないよう、毎回入れ直す
            pendingFeature = el.hasAttribute('data-home-popup-feature');
            pendingRecommend = el.hasAttribute('data-home-popup-recommend');
            pendingPriceDown = el.hasAttribute('data-home-popup-price-down');
            pendingMoveIn = el.hasAttribute('data-home-popup-move-in');
            pendingParking = el.hasAttribute('data-home-popup-parking');
            pendingFloorPlan = el.hasAttribute('data-home-popup-floor-plan');
            pendingLandArea = el.hasAttribute('data-home-popup-land-area');
            pendingLargeDevelopment = el.hasAttribute('data-home-popup-large-development');
            pendingNewsId = el.hasAttribute('data-home-popup-news-detail')
                ? (el.dataset.homePopupNewsId || null)
                : null;
            pendingCmsPriceDown = false;
            pendingCmsNewHouse = false;
            pendingTo = el.dataset.homePopupTo || null;
            open();
        });
    });

    // CMSニュース本文に貼った固定URL。総合版ではこのページ上で都道府県選択ポップアップを開く。
    // エリア選択済みならサーバー側の固定URLリダイレクトへ任せる。
    document.querySelectorAll('.p-news-detail__body a[href]').forEach((link) => {
        const isPriceDown = isCmsLink(link, popup.dataset.cmsPriceDownUrl);
        const isNewHouse = isCmsLink(link, popup.dataset.cmsNewHouseUrl);
        if (!isPriceDown && !isNewHouse) return;

        link.addEventListener('click', (e) => {
            if (isAreaMode()) return;

            e.preventDefault();
            clearPending();
            pendingCmsPriceDown = isPriceDown;
            pendingCmsNewHouse = isNewHouse;
            open();
        });
    });

    // 表示判定: TOP初回のみ（総合版 かつ 同一セッションで未dismiss）
    const isHome = document.body.id === 'page-home';
    let dismissed = false;
    try { dismissed = sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { dismissed = false; }
    const featureRequest = cmsFeatureRequest();
    if (isHome && !isAreaMode() && [CMS_PRICE_DOWN_FEATURE, CMS_NEW_HOUSE_FEATURE].includes(featureRequest)) {
        pendingCmsPriceDown = featureRequest === CMS_PRICE_DOWN_FEATURE;
        pendingCmsNewHouse = featureRequest === CMS_NEW_HOUSE_FEATURE;
        cleanupCmsFeatureRequest();
        window.requestAnimationFrame(open);
        return;
    }

    if (isHome && !isAreaMode() && !dismissed) {
        window.requestAnimationFrame(open);
    }
};

export default main;
